import React from 'react';
import { GraduationCap, Phone, Mail, MapPin, Clock, Send } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white pt-20 pb-8">
      <div className="container mx-auto px-4">
        {/* المحتوى الرئيسي */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {/* معلومات الشركة */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <div className="bg-blue-600 p-3 rounded-lg ml-3">
                <GraduationCap className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-3xl font-bold">النداء</h3>
            </div>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed">
              شريكك التعليمي الموثوق في المملكة العربية السعودية. نقدم دعماً أكاديمياً شاملاً للطلاب في جميع المراحل، من المدرسة الابتدائية إلى الثانوية، مع فريق من المعلمين المؤهلين وذوي الخبرة.
            </p>
            
            {/* وسائل التواصل الاجتماعي */}
            <div>
              <h4 className="text-lg font-semibold mb-4">تابعنا على</h4>
              <div className="flex justify-start">
                <a 
                  href="https://t.me/elneda_education" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 hover:bg-blue-500 p-3 rounded-lg transition-colors duration-300"
                  aria-label="تلجرام"
                >
                  <Send className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
          
          {/* الخدمات */}
          <div>
            <h4 className="text-xl font-semibold mb-6 text-white">خدماتنا</h4>
            <ul className="space-y-4">
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors duration-300 text-lg">
                  شرح المناهج
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors duration-300 text-lg">
                  مساعدة في الواجبات
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors duration-300 text-lg">
                  دعم البحوث
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition-colors duration-300 text-lg">
                  تحضير للاختبارات
                </a>
              </li>
              <li>
                <a href="#stages" className="text-gray-300 hover:text-white transition-colors duration-300 text-lg">
                  جميع المراحل التعليمية
                </a>
              </li>
            </ul>
          </div>
          
          {/* معلومات الاتصال */}
          <div>
            <h4 className="text-xl font-semibold mb-6 text-white">تواصل معنا</h4>
            <div className="space-y-6">
              <div className="flex items-start">
                <Phone className="h-6 w-6 ml-3 mt-1 text-blue-400" />
                <div>
                  <h5 className="font-medium mb-2">الهاتف/واتساب</h5>
                  <a 
                    href="tel:+9660590317360" 
                    className="text-blue-400 hover:text-blue-300 transition-colors text-lg"
                  >
                    0590317360
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <Mail className="h-6 w-6 ml-3 mt-1 text-blue-400" />
                <div>
                  <h5 className="font-medium mb-2">البريد الإلكتروني</h5>
                  <a 
                    href="mailto:info@elnedaa-education.com" 
                    className="text-blue-400 hover:text-blue-300 transition-colors hover:underline"
                  >
                    info@elnedaa-education.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <MapPin className="h-6 w-6 ml-3 mt-1 text-blue-400" />
                <div>
                  <h5 className="font-medium mb-2">المنطقة</h5>
                  <p className="text-gray-300">
                    نخدم الطلاب في جميع أنحاء المملكة العربية السعودية
                  </p>
                </div>
              </div>
            </div>
            
            <div className="mt-8">
              <h5 className="font-medium mb-4 flex items-center">
                <Clock className="h-5 w-5 ml-2 text-blue-400" />
                ساعات العمل
              </h5>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-300">الأحد - الخميس:</span>
                  <span className="text-white font-medium">9:00 ص - 9:00 م</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-300">الجمعة:</span>
                  <span className="text-white font-medium">4:00 م - 9:00 م</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-300">السبت:</span>
                  <span className="text-white font-medium">10:00 ص - 6:00 م</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* الحقوق */}
        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-lg">
            جميع الحقوق محفوظة &copy; {currentYear} خدمات النداء التعليمية
          </p>
          <p className="text-gray-500 mt-2">
            تم التطوير بعناية لخدمة الطلاب في المملكة العربية السعودية
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;